import React, { useContext } from 'react'
import ReactDOM from 'react-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ContentInner } from '../../layout/Content'
import ReceiptsListInnerStyle from './css/ReceiptsListInnerStyle'
import ReceiptItemController from '../receiptitem/ReceiptItemController'
import { formatNumber } from '../../utilities/utilities'
import { receiptsListControllerContext } from './ReceiptsListController'
import { appContext } from '../../../App'
import ModalWindow from '../../layout/modalwindow/ModalWindow'

function ReceiptsListInner() {
  const app = useContext(appContext)
  const setContent = app.content[1]
  const receiptsListController = useContext(receiptsListControllerContext)
  const receiptsList = receiptsListController.receiptsList[0]
  const startSlice = receiptsListController.startSlice[0]
  const endSlice = receiptsListController.endSlice[0]
  const { sortReceiptsListBy, receiptsListSorted, getReceiptById, refreshList } = receiptsListController
  const [sortBy, setSortBy] = receiptsListController.sortBy

  const onClickSort = (e) => {
    const header = e.target.closest('.title-header')
    sortReceiptsListBy(header.id)
    setSortBy(header.id)
  }

  const showMessageBoxReceiptNotFound = async () => {
    const onClick = async () => {
      ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
      refreshList()
    }

    ReactDOM.render(
      <ModalWindow
        id='mw-parent'
        header='Receipt Not Found'
        footer={null}
        width='25'
        height='20'>
        <div className='messagebox'>
          <div className='messagebox-content'>
            <div>Receipt file/record no longer exist!</div>
          </div>
          <div className='button-container'>
            <button onClick={onClick} className='pospro-action-btn top-anchor'>Ok</button>
          </div>
        </div>
      </ModalWindow>,
      document.getElementById('modal-form-container')
    )
  }

  const onClickReceiptItem = async (e) => {
    const receipt_id = e.target.closest('.receipt-item').id
    const receipt_item = await getReceiptById(app, receipt_id)
    if (receipt_item) setContent(<ReceiptItemController receipt={receipt_item}/>)
    else showMessageBoxReceiptNotFound()
  }

  return (
    <ContentInner>
      <div className='receipts-list-table-container'>
        <table className='table striped-table'>
          <thead>
            <tr>
              <th>
                <div
                  id='receipt_date'
                  onClick={onClickSort}
                  className='title-header'>
                  <div>Receipt Date</div>
                  <span>
                    {
                      (sortBy === 'receipt_date') ?
                        (receiptsListSorted) ?
                          <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-up'/>
                          : <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-down-alt'/>
                        : ''
                    }
                  </span>
                </div>
              </th>
              <th>
                <div
                  id='receipt_for'
                  onClick={onClickSort}
                  className='title-header'>
                  <div>Receipt For</div>
                  <span>
                    {
                      (sortBy === 'receipt_for') ?
                        (receiptsListSorted) ?
                          <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-up'/>
                          : <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-down-alt'/>
                        : ''
                    }
                  </span>
                </div>
              </th>
              <th>
                <div
                  id='receipt_amount'
                  onClick={onClickSort}
                  className='title-header'>
                  <div style={{textAlign: 'right'}}>Receipt Amount</div>
                  <span>
                    {
                      (sortBy === 'receipt_amount') ?
                        (receiptsListSorted) ?
                          <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-up'/>
                          : <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-down-alt'/>
                        : ''
                    }
                  </span>
                </div>
              </th>
              <th>
                <div
                  id='paid_by'
                  onClick={onClickSort}
                  className='title-header'>
                  <div>Paid By</div>
                  <span>
                    {
                      (sortBy === 'paid_by') ?
                        (receiptsListSorted) ?
                          <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-up'/>
                          : <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-down-alt'/>
                        : ''
                    }
                  </span>
                </div>
              </th>

              <th>
                <div
                  id='prepared_by'
                  onClick={onClickSort}
                  className='title-header'>
                  <div>Prepared By</div>
                  <span>
                    {
                      (sortBy === 'prepared_by') ?
                        (receiptsListSorted) ?
                          <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-up'/>
                          : <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-down-alt'/>
                        : ''
                    }
                  </span>
                </div>
              </th>
            </tr>
          </thead>
          {
            receiptsList
            .slice(startSlice, endSlice)
            .map(receipt => (
              <tbody
                key={receipt._id}
                id={receipt._id}
                onClick={onClickReceiptItem}
                className='receipt-item'>
                <tr>
                  <td>{new Date(receipt.receipt_date).toLocaleString("en-us", { timeZone: receipt.client_timezone }).split(',')[0]} { receipt.client_timezone}</td>
                  <td>{receipt.receipt_for.item_name}</td>
                  <td style={{textAlign: 'right'}}>P{formatNumber(parseFloat(receipt.amount_to_pay.total_amount) - parseFloat(receipt.discounts.discount_total.total_discount_amount))}</td>
                  <td>{receipt.paid_by}</td>
                  <td>{receipt.prepared_by}</td>
                </tr>
              </tbody>
            ))
          }
        </table>
      </div>
      <ReceiptsListInnerStyle />
    </ContentInner>
  )
}

export default React.memo(ReceiptsListInner)